<script setup lang="ts">
const props = withDefaults(defineProps<{ 
  bold?: boolean;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span';
}>(), {
  as: 'h2'
});
</script>

<template>
  <component
    :is="props.as"
    :class="[
      'text-3xl leading-snug text-on-primary-heading sm:text-4xl lg:text-[44px]',
      props.bold ? 'font-bold' : 'font-medium',
    ]"
  >
    <slot></slot>
  </component>
</template>
